import Store from "../store";

const authorizationResponseCode = 401;

class ApiService {

  constructor(root, modelName, apiExtensions) {
    console.log("Auth Response Code = ", authorizationResponseCode);
    this.apiRoot = root;
    this.modelName = modelName;
    const extensionProps = Object.keys(apiExtensions);
    for (const api in extensionProps) {
      this[extensionProps[api]] = apiExtensions[extensionProps[api]];
    }
  }

  apiGET(context, path, handler, errorCallBack, params) {
    
    context.$http
      .get(this.apiRoot + path, {
        headers: this.getHeaders(),
        params: params
      })
      .then(response => {
        if (response.status == authorizationResponseCode) {
          console.log("Get Redirect");
          context.$router.push("/").catch(error => {
            console.info(error.message);
          });
        } else { 
          if (response.data.success === false) {
            context.$eventHub.$emit("error-happened", response.data);
          } else {
            handler(response.data);
          }
        }       
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == authorizationResponseCode) {
            console.log("Get Redirect");
            context.$router.push("/").catch(error => {
              console.info(error.message);
            });
          } else {
            context.$eventHub.$emit("error-happened", error.response.data);
          }
        }
        if (errorCallBack) {
          errorCallBack(error);
        }
      });
  }

  apiGETOctetStream(context, path, handler, errorCallBack) {
    context.$http
      .get(this.apiRoot + path, {
        headers: {
          ...this.getHeaders(),
          "Content-Type": "application/octet-stream"
        },
        responseType: "blob",
        timeout: 600000
      })
      .then(response => {
        if (response.status == authorizationResponseCode) {
          console.log("Get Octet Redirect");
          context.$router.push("/").catch(error => {
            console.info(error.message);
          });
        } else {
          if (response.data) {
            handler(response.data);
          } else {
            context.$eventHub.$emit("error-happened", response.data);
          }
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == authorizationResponseCode) {
            console.log("Get Octet Redirect");
            context.$router.push("/").catch(error => {
              console.info(error.message);
            });
          } else {
            context.$eventHub.$emit("error-happened", error.response.data);
          }
        }
        if (errorCallBack) {
          errorCallBack(error);
        }
      });
  }

  apiPOST(context, path, data, handler, errorCallBack, noErrorHandling) {
    context.$http
      .post(this.apiRoot + path, data, {
        headers: this.getHeaders(),
        timeout:60000
      })
      .then(response => {
        if (response.status == authorizationResponseCode) {
          console.log("Post Redirect");
          context.$router.push("/").catch(error => {
            console.info(error.message);
          });
        } else { 
          if (response.data.success) {
            handler(response.data, { status: response.status });
          } else {
            if (noErrorHandling !== true) {
              context.$eventHub.$emit("error-happened", response.data);
            }
          }
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == authorizationResponseCode) {
            console.log("Post Redirect");
            context.$router.push("/").catch(error => {
              console.info(error.message);
            });
          } else {
            if (noErrorHandling !== true) {
              context.$eventHub.$emit("error-happened", error.response.data);
            }
          }
        }
        if (errorCallBack) {
          errorCallBack(error);
        }
      });
  }
  
  apiPOSTFormData(context, path, handler, errorCallBack, formData) {
    let config = {
      headers: {
        ...this.getHeaders(),
        "Content-Type": "application/x-www-form-urlencoded"
      }
    };
    context.$http
      .post(this.apiRoot + path, formData, config)
      .then(response => {
        if (response.status == authorizationResponseCode) {
          console.log("Post Form Data Redirect");
          context.$router.push("/").catch(error => {
            console.info(error.message);
          });
        } else { 
          handler(response.data);
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == authorizationResponseCode) {
            console.log("Post Form Data Redirect");
            context.$router.push("/").catch(error => {
              console.info(error.message);
            });
          } else {
            context.$eventHub.$emit("error-happened", error.response.data);
          }
        }
        if (errorCallBack) {
          errorCallBack(error);
        }
      });
  }

  apiPUT(context, path, data, handler, errorCallBack) {
    context.$http
      .put(this.apiRoot + path, data, {
        headers: this.getHeaders()
      })
      .then(response => {
        if (response.status == authorizationResponseCode) {
          console.log("Put Redirect");
          context.$router.push("/").catch(error => {
            console.info(error.message);
          });
        } else {
          if (response != null && response.status == 200) {
            handler(response.data, { status: response.status });
          } else {
            context.$eventHub.$emit("error-happened", response.data);
          }
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == authorizationResponseCode) {
            console.log("Put Redirect");
            context.$router.push("/").catch(error => {
              console.info(error.message);
            });
          } else {
            context.$eventHub.$emit("error-happened", error.response.data);
          }
        }
        if (errorCallBack) {
          errorCallBack(error);
        }
      });
  }

  apiDELETE(context, path, handler, errorCallBack) {
    context.$http
      .delete(this.apiRoot + path, null, {
        headers: this.getHeaders()
      })
      .then(response => {
        if (response.status == authorizationResponseCode) {
          console.log("Delete Redirect");
          context.$router.push("/").catch(error => {
            console.info(error.message);
          });
        } else {
          if (response != null && response.status == 200) {
            handler(response.data, { status: response.status });
          } else {
            context.$eventHub.$emit("error-happened", response.data);
          }
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == authorizationResponseCode) {
            console.log("Delete Redirect");
            context.$router.push("/").catch(error => {
              console.info(error.message);
            });
          } else {
            context.$eventHub.$emit("error-happened", error.response.data);
          }
        }
        if (errorCallBack) {
          errorCallBack(error);
        }
      });
  }

  getHeaders() {
    return {
      Accept: "application/json;charset=UTF-8",
      "Content-Type": "application/json",
      "Accept-Language": Store.getters["localization"],
      "x-rly-corr": 1,
      "x-rly-user-id": Store.getters["user"].id,
      "x-rly-tenant": Store.getters["user"].domainId || 1,
      "x-rly-ins-unit": Store.getters["user"].unitCode || 1,
      "x-rly-session": 1
    };
  }
}

export default ApiService;





// WEBPACK FOOTER //
// ./src/service/ApiService.js